import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Container,
  Stack,
  Typography,
  IconButton,
  Divider,
  alpha,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const HeaderTopbar = (props) => {
  useEffect(() => {
    const savedLang = localStorage.getItem("preferredLang");
    if (!savedLang) return;

    const observer = new MutationObserver(() => {
      const googleSelect = document.querySelector(".goog-te-combo");
      if (
        googleSelect &&
        [...googleSelect.options].some((opt) => opt.value === savedLang)
      ) {
        googleSelect.value = savedLang;
        googleSelect.dispatchEvent(new Event("change"));
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  const handleLanguageClick = (lang) => {
    const langMap = {
      En: "en",
      Jp: "ja",
      Sc: "zh-CN",
      De: "de",
      Tc: "zh-TW",
    };

    const targetLang = langMap[lang];
    if (!targetLang) return;

    const googleSelect = document.querySelector(".goog-te-combo");

    if (
      googleSelect &&
      [...googleSelect.options].some((opt) => opt.value === targetLang)
    ) {
      googleSelect.value = targetLang;
      googleSelect.dispatchEvent(new Event("change"));
    }

    localStorage.setItem("preferredLang", targetLang);
  };

  return (
    <Box
      sx={{
        bgcolor: "#011e63",
        color: "#fff",
        borderBottom: "1px solid rgba(255,255,255,0.1)",
        display: { xs: "none", lg: "block" },
      }}
    >
      <Container maxWidth="xl">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ py: 1 }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <IconButton
              component="a"
              href="https://wa.me/919999632411"
              target="_blank"
              size="small"
              sx={{
                color: "rgba(255,255,255,0.7)",
                "&:hover": { color: "#fff" },
              }}
            >
              <WhatsAppIcon fontSize="inherit" />
            </IconButton>
          </Stack>

          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            divider={
              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  bgcolor: "rgba(255,255,255,0.2)",
                  height: 12,
                  my: "auto",
                }}
              />
            }
          >
            {["En", "Jp", "Sc", "De", "Tc"].map((lang) => (
              <Typography
                key={lang}
                variant="caption"
                onClick={() => handleLanguageClick(lang)}
                sx={{
                  cursor: "pointer",
                  fontWeight: 600,
                  fontSize: "0.75rem",
                  opacity: 0.8,
                  transition: "0.2s",
                  "&:hover": { opacity: 1, color: "var(--turquoise-color)" },
                }}
                className={lang === "En" || lang === "De" ? "notranslate" : ""}
              >
                {lang}
              </Typography>
            ))}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default HeaderTopbar;
